module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTW05-35Thin.dbc068e3.woff2";